<template>
  <el-footer height="35px" class="footer">
    <span>&copy;博彦科技 · 创新研究院北京研发中心</span>
  </el-footer>
</template>
<script>
export default {
  name: 'app-footer',
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/views/layout/app-footer.vue